import { render, staticRenderFns } from "./asset-attribute-dialog.vue?vue&type=template&id=5fe18b08&scoped=true&"
import script from "./asset-attribute-dialog.vue?vue&type=script&lang=js&"
export * from "./asset-attribute-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe18b08",
  null
  
)

export default component.exports